import React, { useState } from 'react';
import { Table, Button, Modal, Typography, Tooltip, Space, Descriptions, Tag, Badge, Flex, Divider, Popover, Spin, Empty, Pagination } from 'antd';
import moment from 'moment';
import { CloseOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import TicketActionModal from './TicketActionModal';
import { useMediaQuery } from 'react-responsive';
import UserTicketModal from './UserTicketView';

const { Text, Title } = Typography;


const MobileRaiseTicket = ({ data, loading, openModal, openUserModal, selectedOption, pagination, setPagination }) => {
    // console.log("selectedOption", selectedOption)

    const columns = [
        {
            title: 'Field',
            dataIndex: 'field',
            key: 'field',
            width: '40%',
            render: (text) => <div strong>{text}</div>,
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            width: '60%',
        },
    ];

    const generateTableData = (item) => [
        { key: '1', field: 'Ticket ID', value: item.ticket_id },
        {
            key: '2',
            field: 'Title',
            value: item.subject,
        },
        {
            key: '3',
            field: 'Category',
            value: item?.category
        },
        {
            key: '4',
            field: 'Reference Ticket ID',
            value: item.reference_ticket ? item.reference_ticket : "N/A",
        },
        {
            key: '5',
            field: 'Status',
            value: (
                <Tag
                    color={item?.status === 'Open' ? 'red' : item?.status === 'Closed' ? 'green' : 'yellow'}
                >
                    {item?.status}
                </Tag>
            ),
        },
        ...(selectedOption === 'my-ticket'
            ? [{
                key: '6',
                field: 'Status Details',
                value: <Button type="link" icon={<EyeOutlined />} onClick={() => openUserModal(item)} />
            }]
            : []
        ),
        {
            key: '7',
            field: 'Created at',
            value: item.created_date ? moment(item.created_date).local().format("DD-MM-YYYY hh:mm A") : 'N/A',
        },
        ...(selectedOption === "all-ticket"
            ? [{
                key: '8',
                field: 'Action',
                value: item.status === "Closed" ? (
                    <Button
                        type="link"
                        icon={<EyeOutlined />}
                        onClick={() => openUserModal(item)}
                    />
                ) : (
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => openModal(item)}
                    />
                ),
            }]
            : []
        ),
    ];

    return (
        <div>
            {loading ? (
                <Spin />
            ) : data && data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: 24 }}>
                        <Table
                            columns={columns}
                            dataSource={generateTableData(item)}
                            pagination={false}
                            showHeader={false}
                            size="small"
                            bordered
                        />
                    </div>

                ))

            ) : (
                <Empty description="No Data Available" />
            )}
            <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={(page, pageSize) =>
                    setPagination((prev) => ({ ...prev, current: page, pageSize }))
                }
                style={{ textAlign: "center", marginTop: 16 }}
            />

        </div>
    );
};

const TicketListTable = ({ loading, data, selectedOption, fetchAllTicketListData, pagination, setPagination, filters }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const [isUserModalOpen, setIsUserModalOpen] = useState(false);


    const columns = [
        {
            title: 'Ticket ID',
            dataIndex: 'ticket_id',
            key: 'ticket_id',
            render: (text, record) => (
                <div>
                    {text}
                    <div style={{ fontSize: '12px', color: '#888' }}>
                        {record.created_date ? moment(record.created_date).local().format("DD-MM-YYYY hh:mm A") : 'N/A'}
                    </div>
                </div>
            ),
        },
        {
            title: 'Title',
            dataIndex: 'subject',
            key: 'title_created_date',
            render: (text, record) => {
                const truncatedText = text && text.length > 15 ? `${text.substring(0, 15)}...` : text;

                return (
                    <div>
                        <Tooltip title={text}>
                            <div style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}>
                                {truncatedText}
                            </div>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (text) => (
                <Tag color="blue">{text}</Tag>
            ),
        },
        {
            title: 'Reference Ticket ID',
            dataIndex: 'reference_ticket',
            key: 'reference_ticket',
            render: (text) => text || 'N/A',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text) => {
                let color = 'gray';

                if (text === 'Open') {
                    color = 'red';
                } else if (text === 'Closed') {
                    color = 'green';
                } else if (text === 'In Progress') {
                    color = 'yellow';
                }

                return (
                    <Tag color={color}>{text}</Tag>
                );
            },
        },
        ...selectedOption === 'my-ticket' ? [{
            title: 'Status Details',
            dataIndex: 'action_on',
            key: 'action_on_details',
            render: (text, record) => {
                return (
                    <div>
                        {/* {record.action_details ? */}
                        <Button onClick={() => openUserModal(record)} type="link" size="small">View</Button>
                        {/* :
                            "N/A"
                        } */}
                    </div>
                );
            },
        }] : [],
        ...selectedOption === 'all-ticket' ? [{
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Space>
                    {record.status === "Closed" ? (
                        <Button
                            type="link"
                            icon={<EyeOutlined />}
                            onClick={() => openUserModal(record)}
                        />
                    ) : (
                        <Button
                            type="link"
                            icon={<EditOutlined />}
                            onClick={() => openModal(record)}
                        />
                    )}
                </Space>
            ),
        }] : []
    ];

    const openModal = (ticket) => {
        setSelectedTicket(ticket);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedTicket(null);
    };

    const openUserModal = (ticket) => {
        setSelectedTicket(ticket);
        setIsUserModalOpen(true);
    };

    const closeUserModal = () => {
        setIsUserModalOpen(false);
        setSelectedTicket(null);
    };

    return (
        <div style={{ width: "100%" }}>
            {isMobile ? (
                <MobileRaiseTicket
                    data={data}
                    loading={loading}
                    openModal={openModal}
                    openUserModal={openUserModal}
                    selectedOption={selectedOption}
                    pagination={pagination}
                    setPagination={setPagination}
                />
            ) : (
                <Table
                    dataSource={data}
                    columns={columns}
                    loading={loading}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        onChange: (page, pageSize) =>
                            setPagination({ ...pagination, current: page, pageSize }),
                    }}
                    scroll={{ x: 'max-content' }}
                />
            )}

            {/* modal for take action by admin */}
            <Modal
                open={isModalOpen}
                onCancel={closeModal}
                styles={{ body: { height: "600px" } }}
                className="create-order"
                width={800}
                maskClosable={false}
                title={
                    <div
                        className="custom-modal-header"
                        style={{ display: "flex", justifyContent: "space-between" }}>
                        <Title
                            level={3}
                            style={{
                                color: "white",
                                margin: 0,
                                position: "relative",
                                left: "12px",
                            }}>
                            {selectedTicket?.ticket_id || ""}
                        </Title>
                        <div style={{ marginRight: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
                            <CloseOutlined
                                style={{ fontSize: "16px", cursor: "pointer", color: "white" }}
                                onClick={closeModal}
                            />
                        </div>
                    </div>
                }
                closable={false}
                footer={[
                    <Flex justify="space-between" align="center" wrap="wrap">
                        <Flex
                            align="center"
                            wrap="wrap"
                            style={{
                                color: '#8c8c8c',
                                rowGap: 8,
                                flex: '1 1 100%',
                            }}
                        >
                            <div>Created By</div>
                            <Divider type="vertical" />
                            <div>{selectedTicket?.created_by || 'N/A'}</div>
                            <Divider type="vertical" />
                            <div>{selectedTicket?.created_by_type || 'N/A'}</div>
                            <Divider type="vertical" />
                            <div>
                                {selectedTicket?.created_date
                                    ? moment(selectedTicket?.created_date).local().format("DD-MM-YYYY hh:mm A")
                                    : 'N/A'}
                            </div>
                        </Flex>
                    </Flex>

                ]}
                bodyStyle={{ maxHeight: "60vh", overflowY: "auto" }}
            >
                {selectedTicket && (
                    <TicketActionModal
                        ticket={selectedTicket}
                        onClose={closeModal}
                        fetchAllTicketListData={fetchAllTicketListData}
                        filters={filters}
                    />
                )}
            </Modal>


            {/* //modal for view the data bu users */}
            <Modal
                open={isUserModalOpen}
                onCancel={closeUserModal}
                styles={{ body: { height: "600px" } }}
                className="create-order"
                width={800}
                maskClosable={false}
                title={
                    <div
                        className="custom-modal-header"
                        style={{ display: "flex", justifyContent: "space-between" }}>
                        <Title
                            level={3}
                            style={{
                                color: "white",
                                margin: 0,
                                position: "relative",
                                left: "12px",
                            }}>
                            {selectedTicket?.ticket_id || ""}
                        </Title>
                        <div style={{ marginRight: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
                            <CloseOutlined
                                style={{ fontSize: "16px", cursor: "pointer", color: "white" }}
                                onClick={closeUserModal}
                            />
                        </div>
                    </div>
                }
                closable={false}
                footer={
                    selectedOption === "all-ticket" ? (
                        <Flex justify="space-between" align="center" wrap="wrap">
                            <Flex
                                align="center"
                                wrap="wrap"
                                style={{
                                    color: "#8c8c8c",
                                    rowGap: 8,
                                    flex: "1 1 100%",
                                }}
                            >
                                <div>Created By</div>
                                <Divider type="vertical" />
                                <div>{selectedTicket?.created_by || "N/A"}</div>
                                <Divider type="vertical" />
                                <div>{selectedTicket?.created_by_type || "N/A"}</div>
                                <Divider type="vertical" />
                                <div>
                                    {selectedTicket?.created_date
                                        ? moment(selectedTicket.created_date).local().format("DD-MM-YYYY hh:mm A")
                                        : "N/A"}
                                </div>
                            </Flex>
                        </Flex>
                    ) : null
                }
                bodyStyle={{ maxHeight: "60vh", overflowY: "auto" }}
            >
                {selectedTicket && (
                    <UserTicketModal
                        ticket={selectedTicket}
                        onClose={closeUserModal}
                        selectedOption={selectedOption}
                    />
                )}
            </Modal>
        </div >
    );
}

export default TicketListTable;
